:host {
  @apply inline-block;
}

.time-picker {
  @apply bg-foreground-1
    shadow-2
    text-color-1
    flex
    select-none
    items-center
    font-medium;

  border-radius: var(--calcite-border-radius);

  .column {
    @apply flex
      flex-col;
  }

  .meridiem--start {
    order: -1;
  }

  .button {
    @apply bg-foreground-1
      inline-flex
      cursor-pointer
      items-center
      justify-center;
    &:hover,
    &:focus {
      @apply bg-foreground-2
        outline-none;
      z-index: theme("zIndex.header");
      outline-offset: 0;
    }
    &:active {
      @apply bg-foreground-3;
    }
    &.top-left {
      border-start-start-radius: var(--calcite-border-radius);
    }
    &.bottom-left {
      border-end-start-radius: var(--calcite-border-radius);
    }
    &.top-right {
      border-start-end-radius: var(--calcite-border-radius);
    }
    &.bottom-right {
      border-end-end-radius: var(--calcite-border-radius);
    }
    calcite-icon {
      @apply text-color-3;
    }
  }

  .input {
    @apply bg-foreground-1
      inline-flex
      cursor-pointer
      items-center
      justify-center
      font-medium;
    &:hover {
      box-shadow: inset 0 0 0 2px var(--calcite-color-foreground-2);
      z-index: theme("zIndex.header");
    }
    &:focus,
    &:hover:focus {
      @apply outline-none;
      outline-offset: 0;
    }
    &.inputFocus,
    &:hover.inputFocus {
      box-shadow: inset 0 0 0 2px var(--calcite-color-brand);
      z-index: theme("zIndex.header");
    }
  }

  &.scale-s {
    @apply text-n1;
    .button,
    .input {
      @apply px-3
        py-1;
    }
    &:not(.show-meridiem) {
      .delimiter:last-child {
        padding-inline-end: theme("spacing.3");
      }
    }
  }

  &.scale-m {
    @apply text-0;
    .button,
    .input {
      @apply px-4
        py-2;
    }
    &:not(.show-meridiem) {
      .delimiter:last-child {
        padding-inline-end: theme("spacing.4");
      }
    }
  }

  &.scale-l {
    @apply text-1;
    .button,
    .input {
      @apply px-5
        py-3;
    }
    &:not(.show-meridiem) {
      .delimiter:last-child {
        padding-inline-end: theme("spacing.5");
      }
    }
  }
}

@include base-component();
